import { ActionEnum } from '../../../enum/action.enum';

export const noop = () => ({type: ActionEnum.NOOP});
